export const COLUMNS = [
  {
    Header: 'Name',
    accessor: 'firstName',
  },
  {
    Header: 'Email',
    accessor: 'email',
  },
  {
    Id: 'Id',
    accessor: '_id',
  },
  {
    Header: 'Role',
    accessor: 'role',
  },
  {
    Header: 'Status',
    accessor: 'status',
  },
  {
    Header: 'Active/Deactive',
    accessor: '',
  },
];
